
        import 'CaptureAddress.946216d.css-module'
        export default {"CaptureAddress":"CaptureAddress_CaptureAddress_946216d","optIns":"optIns_CaptureAddress_946216d","toggle":"toggle_CaptureAddress_946216d"}
    